import { render, staticRenderFns } from "./namedTabs.vue?vue&type=template&id=5f3e5703&scoped=true"
import script from "./namedTabs.vue?vue&type=script&lang=js"
export * from "./namedTabs.vue?vue&type=script&lang=js"
import style0 from "./namedTabs.vue?vue&type=style&index=0&id=5f3e5703&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3e5703",
  null
  
)

export default component.exports